// utils/tableToApi.ts
import type { SorterResult } from 'antd/es/table/interface';

export const priorityMapper: Record<string, string> = {
  1: 'ROUTINE',
  2: 'URGENT',
  3: 'STAT',
};

const COLUMN_TO_API: Record<string, string> = {
  patientFirstName: 'patient',
  patientMedicalRecordNumber: 'mrn',
  studyAccessionNumber: 'accession',
  studyModality: 'study_type',
  priority: 'priority',
  status: 'status',
  studySite: 'study_site',
  studyDate: 'study_date',
  slaStatus: 'sla_timer',
};

export function sorterToOrdering<T = unknown>(
  sorter: SorterResult<T> | SorterResult<T>[]
) {
  const s = Array.isArray(sorter) ? sorter[0] : sorter;
  if (!s?.field || !s?.order) return undefined;
  const apiField = COLUMN_TO_API[String(s.field)];
  if (!apiField) return undefined;
  return s.order === 'descend' ? `-${apiField}` : apiField;
}

/** Split "First Last" into { first, last } heuristically */
export function splitNameQuery(q: string) {
  const parts = q.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return { first: undefined, last: undefined };
  if (parts.length === 1) return { first: parts[0], last: undefined };
  return { first: parts[0], last: parts.slice(1).join(' ') };
}

export const userColumnToApi: Record<string, string> = {
  firstName: 'name',
  email: 'email',
  role: 'role',
  status: 'status',
  lastLogin: 'last_login',
  numberOfAssignments: 'number_of_assignments',
};

export function userSorterToOrdering<T = unknown>(
  sorter: SorterResult<T> | SorterResult<T>[]
) {
  const s = Array.isArray(sorter) ? sorter[0] : sorter;
  if (!s?.field || !s?.order) return undefined;
  const apiField = userColumnToApi[String(s.field)];
  if (!apiField) return undefined;
  return s.order === 'descend' ? `-${apiField}` : apiField;
}

const REPORT_COLUMN_TO_API: Record<string, string> = {
  patientFirstName: 'patient',
  medicalRecordNumber: 'mrn',
  modality: 'modality',
  site: 'site',
  status: 'status',
  signerLastName: 'signer',
  updatedAt: 'updated',
};

export function reportSorterToOrdering<T = unknown>(
  sorter: SorterResult<T> | SorterResult<T>[]
): string | undefined {
  const s = Array.isArray(sorter) ? sorter[0] : sorter;
  if (!s?.field || !s?.order) return undefined;
  const apiField = REPORT_COLUMN_TO_API[String(s.field)];
  if (!apiField) return undefined;
  return s.order === 'descend' ? `-${apiField}` : apiField;
}

export const getColorFromReportStatus = (status: string) => {
  switch (status) {
    case 'PENDING_REVIEW':
      return 'grey';
    case 'FINALIZED':
      return 'darkblue';
    case 'OPEN_ADDENDUM':
      return 'lightblue';
    default:
      return 'grey';
  }
};
